export const BookingProvider = {
    Mahan: "Mahan",
    AccelAero: "AccelAero"
}